import { render, staticRenderFns } from "./RestoreButton.vue?vue&type=template&id=657781df&"
import script from "./RestoreButton.vue?vue&type=script&lang=js&"
export * from "./RestoreButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports